<template>
  <div>
    <vx-card class="mb-8">
      <div class="search-container mb-6 px-0">
        <div
          class="flex flex-col md:flex-row w-full justify-between items-center no-margin gap-4"
        >
          <div
            class="flex-grow flex flex-col md:flex-row items-center w-full md:w-auto gap-4"
          >
            <div class="vx-col w-full md:w-auto md:min-w-300 md:mr-4 pl-0">
              <vs-input
                v-model="searchText"
                placeholder="Search..."
                class="w-full search-field"
                icon-pack="feather"
                icon="icon-search"
                icon-no-border
              />
            </div>

            <div class="vx-col w-full md:w-auto md:mr-4">
              <date-picker
                placeholder="Select date"
                v-model="selectedDate"
                type="date"
                format="DD/MM/YYYY"
                :disabled-date="notAfterToday"
                class="date-picker-field w-full"
              />
            </div>

            <div class="vx-col w-full md:w-auto md:mr-4">
              <vs-select
                v-model="selectedStatus"
                placeholder="Select Status"
                class="w-full status-select"
              >
                <vs-select-item :value="null" text="All Status" />
                <vs-select-item :value="'SUCCESS'" text="Success" />
                <vs-select-item :value="'FAILED'" text="Failed" />
              </vs-select>
            </div>

            <div class="vx-col w-full md:w-auto">
              <div class="flex items-center justify-center md:justify-start">
                <vs-button
                  color="success"
                  type="filled"
                  icon-pack="feather"
                  icon="icon-search"
                  @click.prevent="search"
                  class="mr-2"
                />
                <vs-button
                  color="#67767f"
                  type="filled"
                  icon-pack="feather"
                  icon="icon-refresh-cw"
                  @click.prevent="refreshData"
                />
              </div>
            </div>
          </div>

          <!-- <div class="vx-col download-button">
            <vs-tooltip text="Download Excel Report">
              <div
                class="box toggle-chart"
                @click="downloadExcel"
              >
                <font-awesome-icon
                  icon="fa-solid fa-file-lines"
                  class="large-faicon"
                />
              </div>
            </vs-tooltip>
          </div> -->
        </div>
      </div>
      <vs-table stripe :data="tableData">
        <template slot="thead">
          <vs-th @click="toggleSort('id')" class="text-left cursor-pointer table-header-style">
            <div class="flex items-center">
              <span>No</span>
            </div>
          </vs-th>
          <vs-th @click="toggleSort('date')" class="text-left cursor-pointer table-header-style">
            <div class="flex items-center">
              <span>Date</span>
              <div
                class="ml-4 flex flex-col sort-icon-group"
                @click.stop="toggleSort('date')"
                style="cursor: pointer"
              >
                <font-awesome-icon
                  :icon="['fas', 'caret-up']"
                  :class="getSortClass('date', 'asc')"
                />
                <font-awesome-icon
                  :icon="['fas', 'caret-down']"
                  :class="getSortClass('date', 'desc')"
                />
              </div>
            </div>
          </vs-th>
          <vs-th @click="toggleSort('time')" class="text-left cursor-pointer table-header-style">
            <div class="flex items-center">
              <span>Time</span>
              <div
                class="ml-4 flex flex-col sort-icon-group"
                @click.stop="toggleSort('time')"
                style="cursor: pointer"
              >
                <font-awesome-icon
                  :icon="['fas', 'caret-up']"
                  :class="getSortClass('time', 'asc')"
                />
                <font-awesome-icon
                  :icon="['fas', 'caret-down']"
                  :class="getSortClass('time', 'desc')"
                />
              </div>
            </div>
          </vs-th>
          <vs-th @click="toggleSort('description')" class="text-left cursor-pointer table-header-style">
            <div class="flex items-center">
              <span>Description</span>
              <div
                class="ml-4 flex flex-col sort-icon-group"
                @click.stop="toggleSort('description')"
                style="cursor: pointer"
              >
                <font-awesome-icon
                  :icon="['fas', 'caret-up']"
                  :class="getSortClass('description', 'asc')"
                />
                <font-awesome-icon
                  :icon="['fas', 'caret-down']"
                  :class="getSortClass('description', 'desc')"
                />
              </div>
            </div>
          </vs-th>
          <vs-th @click="toggleSort('status')" class="text-left cursor-pointer table-header-style">
            <div class="flex items-center">
              <span>Status</span>
              <div
                class="ml-4 flex flex-col sort-icon-group"
                @click.stop="toggleSort('status')"
                style="cursor: pointer"
              >
                <font-awesome-icon
                  :icon="['fas', 'caret-up']"
                  :class="getSortClass('status', 'asc')"
                />
                <font-awesome-icon
                  :icon="['fas', 'caret-down']"
                  :class="getSortClass('status', 'desc')"
                />
              </div>
            </div>
          </vs-th>
          <vs-th @click="toggleSort('backupFile')" class="text-left cursor-pointer table-header-style">
            <div class="flex items-center">
              <span>Backup File</span>
              <div
                class="ml-4 flex flex-col sort-icon-group"
                @click.stop="toggleSort('backupFile')"
                style="cursor: pointer"
              >
                <font-awesome-icon
                  :icon="['fas', 'caret-up']"
                  :class="getSortClass('backupFile', 'asc')"
                />
                <font-awesome-icon
                  :icon="['fas', 'caret-down']"
                  :class="getSortClass('backupFile', 'desc')"
                />
              </div>
            </div>
          </vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr class="pln-color" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="indextr">
              {{ (currentPage - 1) * itemsPerPage + indextr + 1 }}
            </vs-td>

            <vs-td class="text-left" :data="tr.date">
              {{ tr.date }}
            </vs-td>

            <vs-td class="text-left" :data="tr.time">
              {{ tr.time }}
            </vs-td>

            <vs-td class="text-left" :data="tr.description">
              {{ tr.description }}
            </vs-td>

            <vs-td class="text-left" :data="tr.status">
              <div class="flex justify-start items-center">
                <vs-chip :color="tr.status === 'SUCCESS' ? '#4CAF50' : '#9E9E9E'" icon-pack="feather">
                  {{ tr.status === 'SUCCESS' ? 'Success' : 'Failed' }}
                </vs-chip>
              </div>
            </vs-td>

            <vs-td class="text-left" :data="tr.backupFile">
              {{ tr.backupFile || '-' }}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <div class="flex justify-between mt-4">
        <div class="flex" style="align-items: center">
          <span class="mr-2">show data</span>
          <vs-select
            style="width: 25%"
            v-model="itemsPerPage"
            @input="updateItemsPerPage"
          >
            <vs-select-item
              v-for="(option, index) in pageOptions"
              :key="index"
              :value="option.value"
              :text="option.text"
            />
          </vs-select>
        </div>
        <CustomPagination
          :current-page.sync="currentPage"
          :total-pages="totalPages"
          :total-data="totalData"
          @update:currentPage="getCleansingLog"
        />
      </div>
    </vx-card>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import CustomPagination from "@/components/CustomPagination.vue";
import api from "@/api";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCaretUp, faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faCaretUp, faCaretDown);

export default {
  components: {
    DatePicker,
    CustomPagination,
    "font-awesome-icon": FontAwesomeIcon,
  },
  data() {
    return {
      searchText: "",
      selectedDate: null,
      selectedStatus: null,
      currentPage: 1,
      itemsPerPage: 10,
      pageOptions: [
        { value: 10, text: '10' },
        { value: 25, text: '25' },
        { value: 50, text: '50' },
        { value: 100, text: '100' }
      ],
      tableData: [],
      totalData: 0,
      sortField: "",
      sortOrder: "asc",
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalData / this.itemsPerPage);
    }
  },
  mounted() {
    this.getCleansingLog();
  },
  methods: {
    // update items per page (page handling)
    updateItemsPerPage() {
      this.currentPage = 1;
      this.getCleansingLog();
    },
    notAfterToday(date) {
      return date > new Date(new Date().setHours(23, 59, 0, 0));
    },
    search() {
      this.currentPage = 1;
      this.getCleansingLog();
    },
    refreshData() {
      // reset all filter
      // this.searchText = "";
      // this.selectedDate = null;
      // this.selectedStatus = null;
      // this.currentPage = 1;
      // this.sortField = "";
      // this.sortOrder = "asc";
      this.getCleansingLog();
    },
    getCleansingLog() {
      this.$vs.loading();
      const params = {
        page: this.currentPage,
        limit: this.itemsPerPage,
      };

      if (this.searchText) {
        params.search = this.searchText;
      }

      if (this.selectedDate) {
        const date = new Date(this.selectedDate);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        params.date = `${year}-${month}-${day}`;
      }

      if (this.selectedStatus) {
        params.status = this.selectedStatus;
      }

      if (this.sortField) {
        params.sort = `${this.sortField} ${this.sortOrder}`;
      }

      console.log("📦 [getCleansingLog] API Params:", params);

      api
        .getCleansingLog(params)
        .then((result) => result.data)
        .then((data) => {
          console.log("✅ [getCleansingLog] Response:", data);
          if (data.status) {
            this.tableData = data.data;
            this.totalData = data.totalData;
          }
          this.$vs.loading.close();
        })
        .catch((e) => {
          console.error("❌ [getCleansingLog] Error:", e);
          this.$vs.loading.close();
        });
    },
    toggleSort(field) {
      console.log("🔽 [toggleSort] Clicked field:", field);

      if (this.sortField === field) {
        this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
      } else {
        this.sortField = field;
        this.sortOrder = "asc";
      }

      console.log("🔄 [toggleSort] New sortField:", this.sortField);
      console.log("🔄 [toggleSort] New sortOrder:", this.sortOrder);

      this.getCleansingLog();
    },
    getSortClass(field, direction) {
      const isActive = this.sortField === field && this.sortOrder === direction;
      return {
        "sort-icon": true,
        active: isActive,
      };
    },
    async downloadExcel() {
      try {
        this.$vs.loading();

        const params = {};

        if (this.searchText) {
          params.search = this.searchText;
        }

        if (this.selectedDate) {
          const date = new Date(this.selectedDate);
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          params.date = `${year}-${month}-${day}`;
        }

        console.log("📥 [downloadExcel] API Params:", params);

        const response = await api.getLogAuditExcel(params, {
          responseType: "blob",
        });

        // Create a download
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `log-audit-${new Date().getTime()}.xlsx`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(link.href);

        this.$vs.notify({
          title: "Success",
          text: "Excel report downloaded successfully",
          color: "success",
          position: "top-right",
        });

        this.$vs.loading.close();
      } catch (error) {
        console.error("❌ [downloadExcel] Error:", error);
        this.$vs.notify({
          title: "Failed",
          text: "Failed to download Excel report",
          color: "danger",
          position: "top-right",
        });
        this.$vs.loading.close();
      }
    },
  },
};
</script>

<style scoped>
.search-container {
  width: 100%;
}

.no-margin {
  margin: 0;
}

.search-field {
  width: 100%;
}

.date-picker-field {
  width: 100%;
}

.status-select {
  width: 100%;
}

@media (min-width: 768px) {
  .search-field {
    min-width: 300px;
  }

  .date-picker-field {
    min-width: 220px;
  }

  .status-select {
    width: auto;
    min-width: 150px;
  }
}

.download-button {
  padding-right: 1rem;
}

.large-faicon {
  font-size: 42px;
  color: #1372ac;
  margin-right: 0;
}

.box.toggle-chart {
  cursor: pointer;
}

/* Style adjustments for the table */
.vs-table {
  margin-top: 1rem;
  width: 100%;
  border: 1px solid #eee;
  border-radius: 8px;
}

.table-header-style {
  font-weight: 600;
  color: #444;
  padding: 1rem;
}

.vs-table--thead {
  background-color: #f8f8f8;
}

.vs-table--tbody > .vs-table--tr {
  border-bottom: 1px solid #eee;
}

.vs-table--td {
  padding: 0.75rem 1rem;
}

.sort-icon-group {
  line-height: 0.7;
}

.sort-icon {
  color: white;
  font-size: 12px;
  transition: opacity 0.2s ease;
}

.sort-icon.active {
  opacity: 1;
  color: #009fb2;
}

.cursor-pointer {
  cursor: pointer;
}
</style>
